import { normalizeAllowedModules } from "../utils/moduleEntryResolver";

// UI visibility only: every corporate API request also checks persisted grants.
export function canAccessCorporatePurchasing(user) {
  const corporateModules = Array.isArray(user?.corporate_modules)
    ? user.corporate_modules
    : [];
  return Number(user?.id) === 1 ||
    normalizeAllowedModules(corporateModules).includes("corporate_purchasing");
}
